import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';
import EmailProviderCard from './EmailProviderCard';
import { emailIntegrationService } from '@/_services/api/emailIntegration';
import { EMAIL_PROVIDERS } from './emailProviders';
import { FullViewLoadingSpinner } from '@/_elements/Loaders';
import { calendarIntegrationUtils } from '../../CalendarIntegration/utils/utils';

const EmailConnect = ({ icon, title, description, emailProvider, fetchAccounts, handleClose = () => {} }) => {
    const [isBusy, setIsBusy] = useState(false);
    const handleConnect = async () => {
        try {
            setIsBusy(true);
            const response = await emailIntegrationService.authorizeEmail({ provider: emailProvider });
            if (response && response.authUrl) {
                poptastic(response.authUrl);
            } else {
                toast.error('Authorization URL not available');
            }
        } catch (error) {
            toast.error(error?.message || 'Failed to get authorization');
        } finally {
            setIsBusy(false);
            fetchAccounts();
            handleClose();
        }
    };
    return (
        <div className="mb-3  border  rounded p-3 d-flex flex-row justify-content-between">
            <div className="d-flex flex-row">
                <div>{icon}</div>
                <div className="d-flex flex-column ml-4">
                    <div>{title}</div>
                    <div className="text-muted">{description}</div>
                </div>
            </div>
            <div>
                <Button variant="primary" onClick={() => handleConnect()} disabled={isBusy}>
                    {isBusy ? 'Connecting...' : 'Connect'}
                </Button>
            </div>
        </div>
    );
};

const poptastic = (url) => {
    var newWindow = window.open(url, 'name', 'height=700,width=1000');
    if (window.focus) {
        newWindow.focus();
    }
};

const PersonalCalendars = ({ handleClose = () => {} }) => {
    const [accounts, setAccounts] = useState([]);
    const [isBusy, setIsBusy] = useState(false);

    const fetchAccounts = async () => {
        try {
            setIsBusy(true);
            const response = await emailIntegrationService.getEmailAccounts();
            setAccounts(response?.results || response?.data || []);
        } catch (error) {
            if (error?.name !== 'AbortError') {
                toast.error(error?.message || 'Failed to load email accounts');
            }
        } finally {
            setIsBusy(false);
        }
    };

    useEffect(() => {
        fetchAccounts();
    }, []);

    if (isBusy) {
        return <FullViewLoadingSpinner size={'30vh'} />;
    }
    return (
        <div className="w-100 p-4">
            {accounts.map((account) => (
                <EmailProviderCard
                    key={account._id}
                    account={{
                        ...account,
                        displayName: calendarIntegrationUtils.formatProviderName(account?.emailProvider || ''),
                    }}
                    fetchAccounts={fetchAccounts}
                />
            ))}

            <EmailConnect
                icon={EMAIL_PROVIDERS.GMAIL.icon}
                title="Gmail"
                description={'Connect Gmail & choose channel where incoming email will be copied.'}
                fetchAccounts={fetchAccounts}
                emailProvider="GMAIL"
                handleClose={handleClose}
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    currUser: state.user.user,
});
export default connect(mapStateToProps)(PersonalCalendars);
